import {Button, Typography, PlayIcon} from '@genestack/ui';
import React from 'react';

import {useRunQueryMutation} from '../../../hooks/requests/use-run-query-mutation';
import {useUpdateQueryMutation} from '../../../hooks/requests/use-update-query-mutation';

import styles from './query-draft-footer.module.css';
import {GlobalVersionData} from '../../../../../hooks/global-version/use-global-version-query';
import {VersionSelect} from '../../../../../hooks/global-version/version-select/version-select';
import {useSidebarTabs} from '../../../../../hooks/use-sidebar-tabs';
import {QueriesTab} from '../../../../../components/layout/page-layout/layout-typings';

interface Props {
    queryDraft: DraftQuery;
    globalVersions: GlobalVersionData[];
    sidebarTabsProps: ReturnType<typeof useSidebarTabs>;
}

export function QueryDraftFooter(props: Props) {
    const runQuery = useRunQueryMutation();
    const updateQuery = useUpdateQueryMutation();

    const handleRunQuery = () => {
        runQuery.mutate(props.queryDraft.id);
        props.sidebarTabsProps.setActivityBarTab(QueriesTab.RUNNING);
    };

    const handleChangeDraftVersion = (globalVersionId: number) => {
        updateQuery.mutate({id: props.queryDraft.id, globalVersionId});
    };

    return (
        <div className={styles.root}>
            <div className={styles.actions}>
                {!props.queryDraft.trash ? (
                    <Button
                        icon={<PlayIcon />}
                        onClick={handleRunQuery}
                        disabled={runQuery.isPending}
                    >
                        Run query
                    </Button>
                ) : null}
            </div>

            <div className={styles.version}>
                <Typography className={styles.versionLabel} as="span" intent="quiet">
                    KB Version:
                </Typography>
                <VersionSelect
                    value={props.queryDraft.globalVersionId}
                    onChangeValue={handleChangeDraftVersion}
                    disabled={runQuery.isPending}
                    globalVersions={props.globalVersions}
                />
            </div>
        </div>
    );
}
